import { ViewModel, View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { BankSelectorViewModel } from "src/erp/arap/rawData/bank/bankSelector-viewModel";
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { PosDeviceManipulationView } from "./posDeviceManipulation-view"

export class PosDeviceManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("posDeviceManipulation-viewModel.definePose", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.posDevice = ObservableArray.create<posDevice>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new PosDeviceManipulationView();
    }
    public getTypeId(): string {
        return "VM-44851D39-66C1-4557-A467-F7820E0226E0"
    } public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set posDevice(v: ObservableArray<posDevice>) { this._posDevice = v; } public get posDevice(): ObservableArray<posDevice> { return this._posDevice; } private _posDevice: ObservableArray<posDevice>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    refresh() {
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/GetAllPosDevice', {
                FilteringInformation: filteringInformation
            });
            let rowNumber = 1;
            this.posDevice.update(...result.PosDevice.map(q => {
                let r = new posDevice(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.bankId = q.OwnerBankId;
                r.bankName = q.BankName;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.name = q.PosName;
                r.serialNumber = q.SerialNumber;
                r.terminalId = q.TerminalId;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestPosDeviceCreation() {
        let editor = new posDeviceEditor(this, new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }

    async posDeviceUpdater(posDevice: posDevice) {
        let editor = new posDeviceEditor(this, new UpdateServerUpdater());
        posDevice.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }
}

export class posDevice extends ViewModel {

    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: PosDeviceManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set terminalId(v: string) { this._terminalId = v; } public get terminalId(): string { return this._terminalId; } private _terminalId: string;
    public set serialNumber(v: string) { this._serialNumber = v; } public get serialNumber(): string { return this._serialNumber; } private _serialNumber: string;

    public set bankId(v: string) { this._bankId = v; } public get bankId(): string { return this._bankId; } private _bankId: string;
    public set bankName(v: string) { this._bankName = v; } public get bankName(): string { return this._bankName; } private _bankName: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId; } private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;

    private _typedParent: PosDeviceManipulationViewModel;

    cloneTo(posDevice: posDevice) {
        posDevice.id = this.id;
        posDevice.name = this.name;
        posDevice.terminalId = this.terminalId;
        posDevice.serialNumber = this.serialNumber;
        posDevice.setDistrict(this.getDistrictId(), this.districtName);
        posDevice.setBank(this.getBankId(), this.bankName);
    }

    setBank(id: string, name: string) {
        this.bankId = id;
        this.bankName = name;
    }
    getBankId() {
        return this.bankId;
    }

    setDistrict(id: string, name: string) {
        this.districtId = id;
        this.districtName = name;
    }
    getDistrictId() {
        return this.districtId;
    }

    async edit() {
        this._typedParent.posDeviceUpdater(this);
    }
}

interface IServerUpdater {
    execute(posDevice: posDevice): Promise<void>;
    getSuccessMessage(): string;
}

class InsertServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return translate("posDeviceManipulation-viewModel.successfullyRegistered", {});
    }
    async execute(posDevice: posDevice): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/CreatePosDevice', {
            DistrictId: posDevice.getDistrictId(),
            BankId: posDevice.getBankId(),
            PosName: posDevice.name,
            SerialNumber: posDevice.serialNumber,
            TerminalId: posDevice.terminalId,

        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
    }
}

class UpdateServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return translate("posDeviceManipulation-viewModel.successfullyUpdated", {});
    }
    async execute(posDevice: posDevice): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/UpdatePosDevice', {
            Id: posDevice.id,
            DistrictId: posDevice.getDistrictId(),
            BankId: posDevice.getBankId(),
            PosName: posDevice.name,
            SerialNumber: posDevice.serialNumber,
            TerminalId: posDevice.terminalId
        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
    }
}

export class posDeviceEditor extends posDevice implements IPopup {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }

    constructor(parent: PosDeviceManipulationViewModel, serverUpdater: IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.bankSelector = new BankSelectorViewModel(this);
        this.districtSelector = new DistrictSelector(this);
    }
    closePopup(resultCode: string = null) {
    }

    private _serverUpdater: IServerUpdater;
    public set bankSelector(v: BankSelectorViewModel) { this._bankSelector = v; } public get bankSelector(): BankSelectorViewModel { return this._bankSelector; } private _bankSelector: BankSelectorViewModel;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector; } private _districtSelector: DistrictSelector;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push(translate("posDeviceManipulation-viewModel.poseNameError", {}));
        }
        if (stringIsNullOrEmpty(this.serialNumber)) {
            result.push(translate("posDeviceManipulation-viewModel.poseSerialNumberError", {}));
        }
        if (stringIsNullOrEmpty(this.terminalId)) {
            result.push(translate("posDeviceManipulation-viewModel.poseTerminalNumber", {}));
        }
        if (stringIsNullOrEmpty(this.getBankId())) {
            result.push(translate("posDeviceManipulation-viewModel.bankError", {}));
        }
        if (stringIsNullOrEmpty(this.getDistrictId())) {
            result.push(translate("posDeviceManipulation-viewModel.branchError", {}));
        }
        return result;
    }

    setDistrict(id: string, name: string) {
        this.districtSelector.selectById(id);
    }

    getDistrictId() {
        return this.districtSelector.selectedItem?.id;
    }

    setBank(id: string, name: string) {
        this.bankSelector.selectById(id);
    }

    getBankId() {
        return this.bankSelector.selectedItem?.id;
    }

    async save() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage, translate("posDeviceManipulation-viewModel.unableToRegister", {}));
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(), translate("posDeviceManipulation-viewModel.successfulOperation", {}));
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(translate("posDeviceManipulation-viewModel.operationErorr", {}), translate("posDeviceManipulation-viewModel.error", {}));
        } finally {
            this.isLoading = false;
        }
    }

    back() {
        this.closePopup();
    }

}

export class PosDeviceSelectorViewModel extends SelectorBaseViewModel<posDeviceForSelector> {
    protected async loadData(): Promise<posDeviceForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/GetAllPosDevice', {});
        return result.PosDevice.map(q => {
            let result = new posDeviceForSelector(this);
            result.id = q.Id;
            result.title = q.PosName;
            return result;
        });
    }

}

class posDeviceForSelector extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}